import { useNavigate } from 'react-router-dom';
import "../styles/Hero.css";
import { handleStart } from '../components/gameStart';


function Hero() {
   const navigate = useNavigate();

   const onNavigate = (path) => () => {
      console.log(`Navigating to ${path}`);
      navigate(path);
   }
   
   return (
      <div className="hero">
         <div className="logoWrapper">
            <img src="/assets/images/logo.png" alt="DisinfoQuest logo" className="logo" />
         </div>
         
         <div className="heroButtonContainer">
            
            <button className="heroButton" onClick={() => {
                const aboutSection = document.getElementById("about");
                if (aboutSection) {
                aboutSection.scrollIntoView({ behavior: "smooth" });
                }
            }}>ABOUT</button>
            
            <button className="heroButton heroButtonPrimary" onClick={handleStart}>PLAY</button>
            <button className="heroButton" onClick={onNavigate('/learn')}>LEARN</button>
         
         </div>
      </div>
      
   );
 }
 
 export default Hero;